import React, {useDebugValue, useState} from "react";
import IsMobile from "../IsMobile";
import {NewsPostData} from "../Data Types/NewsPostData";
import {selectNewsPost, setSelectedPost, setSelectedPostId, clearNewsError, selectNewsPosts} from "../Redux Store/actions";
import store, {AppDispatch} from "../Redux Store/store";
import {useDispatch, useSelector} from 'react-redux';
import {useApi} from "../Constants";
import {stringifyDate} from "../Helper Scripts/DateHelper";
import {RootState} from "../Redux Store/reducers";

// NewsPostData.tsx is a generic news data, both for the small list panels, and the full large view.
// Out of it, some of the data will be here in these props:
type NewsPanelElementProps = {
    newsId: string;
    title: string;
    date: string;
    panelClickUrl?: string;  // The primary associated media.

    thumbnailUrl?: string;
    isPixelated?: boolean;
}
const NewsPanelElement = ({newsId, title, date, panelClickUrl, thumbnailUrl, isPixelated = false}: NewsPanelElementProps) => {
    const dispatch: AppDispatch = useDispatch();
    const isSelected = useSelector((state: RootState) => state.selectedPost)?.id == newsId;
    //const isSelected = useSelector() == newsId;
    //     const selectedPost = useSelector((state: RootState) => state.selectedPost); // Accessing the data from Redux store


    const hasPanelClickUrl = panelClickUrl != null;

    // Overrides <a/> appearance. Cursor stays the same though, because clicking on a news panel causes a news post to be displayed.
    const unclickableStyle: any = {
            //pointerEvents: ("none style" as React.CSSProperties["pointerEvents"]),
            cursor: "pointer",
            textDecoration: "none",
            color: "#fff",
        };
    const renderThumbnailAsPixelArt: any = isPixelated ?
        { imageRendering: "pixelated",}
        :
        {};
    const selectedStyle: any = isSelected ?
        { backgroundColor: "#a167b7",}
        :
        {};

    function OnClick(/*eventvar*/){
        //newsID
        //setSelectedPostId(newsId);
        console.log(`setSelectedPostId(${newsId});`);
        //dispatchMethod = fetchPost(newsId);  // Currently, this method does setSelectedPost().
        //store.dispatch({type: "SET_SELECTED_POST_ID", payload: newsId});
        //dispatch({type: "SET_SELECTED_POST_ID", payload: newsId});//
        dispatch(setSelectedPostId(newsId));
        dispatch(selectNewsPost(newsId/*, useApi*/));
        //store.dispatch({type: "SET_SELECTED_POST", payload: {what: "what"}});
        /*let newsPost = *///fetchPost(newsId);
        //setSelectedPost(newsPost);
    }

    const isMobile = IsMobile();

    // TODO: Have a tiny overlay icon button: <a href={panelClickUrl}/>
    return <a onClick={OnClick}
       className="news-panel"
       style={{
           position: "relative", marginBottom: isMobile ? 0 : "8px",
           width: isMobile ? "80%" : "100%", height: isMobile ? "6vh" : "14vh",
           display: "flex", flexDirection: "row", justifyContent: "space-between",
           ...unclickableStyle, ...selectedStyle,
       }}>
        <div style={{
            margin: 0, padding: isMobile ? 0 : "8px",
            minWidth: 0,
            textAlign: "left",
        }}>
            <p style={{
                fontSize: "1em",
                marginBottom: "0.2rem",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                padding: isMobile ? "4px" : "auto",
            }}>{title}</p>

            {!isMobile && <p style={{
                fontSize: "0.9em", color: "#9badb7",
                marginBottom: "0.2rem",
            }}>{date}</p>}
        </div>
        <img style={{
            borderRadius: "8%",
            aspectRatio: "16/9",
            ...renderThumbnailAsPixelArt
        }}
             src={thumbnailUrl == null ? "/Images/YouTube Video Thumbnails/Music/Default Thumbnail.jpg" : thumbnailUrl}/>

        {panelClickUrl &&
        <div style={{position: "absolute", top: "2px", right: "2px", width: "20px", height: "20px",
            backgroundColor: "#00000080",
            borderRadius: "8px",
                display: "flex", alignItems: "center", justifyContent: "center",
            }}>
                <div onClick={(e) => {
                    e.stopPropagation(); // Prevent outer <a> from triggering
                    window.open(panelClickUrl, "_blank");
                }}>
                    {/*https://icons.getbootstrap.com/icons/link/*/}
                <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" fill="#d77bba"
                    className="bi bi-link" viewBox="0 0 16 16">
                    <path
                        d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
                    <path
                        d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z" />
                </svg>
            </div>
        </div>}
    </a>
}


type NewsPanelElementScrollerProps = {
    newsPanelElements: React.JSX.Element[];  // ASSUMPTION: These are of the type <NewsPanelElement/>.
}
const NewsPanelElementScroller = ({newsPanelElements,}: NewsPanelElementScrollerProps) => {
    const useNewsIndex = () =>{
        const [newsIndex, setNewsIndex] = useState(0);
        useDebugValue(newsIndex, n => n);
        return {newsIndex, setNewsIndex};
    }

    const {newsIndex, setNewsIndex} = useNewsIndex();
    let elementCount = newsPanelElements.length;
    let currentElement = newsPanelElements[newsIndex];

    return <div style={{display: "flex", justifyContent: "row", alignItems: "center", height: "100%",}}>
        <a style={{width: "10%",}} onClick={() => setNewsIndex((newsIndex - 1 + elementCount) % elementCount)}>&lt;</a>
        {currentElement}
        <a style={{width: "10%",}} onClick={() => setNewsIndex((newsIndex + 1) % elementCount)}>&gt;</a>
    </div>;
}


const NewsPanelHeaderStyle_NonMobile: any = {marginBottom: "16px", marginLeft: "4px", marginRight: "4px",};
const NewsPanelHeaderStyle_Mobile: any = {marginBottom: "16px", marginLeft: "4px", marginRight: "4px",};
const NewsPanelHeaderStyle: any = IsMobile() ? NewsPanelHeaderStyle_Mobile : NewsPanelHeaderStyle_NonMobile;

const NewsPanelStyle_NonMobile: any = {
    width: "100%", height: "100%",
    fontSize: "0.75rem",
};
const NewsPanelStyle_Mobile: any = {
    width: "90%", height: "100%",
    padding: "8px",
    fontSize: "0.75rem",
    // display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center",
    backgroundColor: "rgb(118, 66, 138)",
    boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
};
const NewsPanelStyle: any = IsMobile() ? NewsPanelStyle_Mobile : NewsPanelStyle_NonMobile;

const NewsPanelBackgroundStyle_NonMobile = {width: "90%", height: "100%", margin: "auto",
    backgroundColor: "rgb(118, 66, 138)",
    boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",}
const NewsPanelBackgroundStyle_Mobile = {width: "90%", height: "100%", margin: "auto",}
const NewsPanelBackgroundStyle: any = IsMobile() ? NewsPanelBackgroundStyle_Mobile : NewsPanelBackgroundStyle_NonMobile;

// TODO OPTIONAL: Put these in a folder?
//  Get all .jsons in that folder, and make elements outta theme?
//  Or perhaps in the perfect situation, get em from a file server.

// TODO: Find a solution to the displaying of several posts that are scrollable. A Bootstrap carousel?
/*const newsPosts: NewsPostData[] = [
    {
        id: "NEWS-SONIC_CHIP_COLLAB_CHAOS",
        title: "Sonic Chip Collab Chaos is Out!",
        tags: ["remix", "chiptune", "sonic"],
        releaseDate: new Date("2025-06-04"),
        panelClickUrl: "https://www.youtube.com/watch?v=Uw_UxP7OmJ4",
        thumbnailUri: "/Images/YouTube Video Thumbnails/Music/SonicChipCollabChaosImage.jpg",
        isPixelated: false,
    },
    {
        id: "NEWS-METAPHOR_JAM_VICTORY",
        title: "Metaphor won a game jam!",
        tags: ["game, metaphor"],
        releaseDate: new Date("2025-05-05"),
        panelClickUrl: "https://blawnode.itch.io/metaphor-a-dream-journal",
        thumbnailUri: "/Images/News Exclusive Thumbnails/Metaphor Won Thumbnail.png",
        isPixelated: true,
    },
    {
        id: "NEWS-METAPHOR_JAM_RELEASE",
        title: "Metaphor (game jam) is released!",
        tags: ["game, metaphor"],
        releaseDate: new Date("2025-04-28"),
        panelClickUrl: "https://blawnode.itch.io/metaphor-a-dream-journal",
        thumbnailUri: "/Images/Game Thumbnails/Metaphor Thumbnail.png",
        isPixelated: true,
    },
    {
        id: "NEWS-INWEB_GAME-INSOMNIAC_MOLES_MORE_CONTROLS",
        title: "More controls! - Insomniac Moles",
        tags: ["game", "update", "blawnode_com", "insomniac_moles"],
        releaseDate: new Date("2025-03-25"),
        panelClickUrl: "/games/insomniac_moles",  // Inweb game url! Like, href="/games/insomniac_moles"
        thumbnailUri: "/Images/Game Thumbnails/Insomniac Moles News Thumbnail.png",
        isPixelated: true,
    },
    {
        id: "NEWS-STYLE_GOBLIN_VER1_1_WIP",
        title: "Style Goblin 1.1 in the Works!",
        tags: ["game, style_goblin"],
        releaseDate: new Date("2025-03-08"),
        panelClickUrl: "https://blawnode.itch.io/style-goblin",
        thumbnailUri: "/Images/Game Thumbnails/eliza Closeup Banner 640x360.png",
        isPixelated: false,
    },
    {
        id: "NEWS-INWEB_GAME-INSOMNIAC_MOLES",
        title: "Play Now! - Insomniac Moles",
        tags: ["game", "blawnode_com", "insomniac_moles"],
        releaseDate: new Date("2024-11-11"),
        panelClickUrl: "/games/insomniac_moles",  // Inweb game url! Like, href="/games/insomniac_moles"
        thumbnailUri: "/Images/Game Thumbnails/Insomniac Moles News Thumbnail.png",
        isPixelated: true,
    },
    {
        id: "NEWS-WEBSITE_MAINTANENCE2",
        title: "Website maintenance - Redux Implemented!",
        tags: ["blawnode_com"],
        releaseDate: new Date("2024-10-21"),
        thumbnailUri: "/Images/News Exclusive Thumbnails/bn_com maintenance news thumbnail 2.png",
        isPixelated: true,
    },
    {
        id: "NEWS-WEBSITE_MAINTANENCE1",
        title: "New ongoing website maintenance!",
        tags: ["blawnode_com"],
        releaseDate: new Date("2024-09-06"),
        thumbnailUri: "/Images/News Exclusive Thumbnails/bn_com maintenance news thumbnail 1.png",
        isPixelated: true,
    },
    {
        id: "NEWS-NUISANCE_RELEASE",
        title: "Nuisance is released!",
        tags: ["game, nuisance"],
        releaseDate: new Date("2024-09-04"),
        panelClickUrl: "https://blawnode.itch.io/nuisance",
        thumbnailUri: "/Images/Game Thumbnails/Nuisance Thumbnail 16x9.png",
        isPixelated: true,
    },
    {
        id: "NEWS-REMIX_LA_PLAISANTERIE_SAVANTE",
        title: "EBF5 Remix: La Plaisanterie Savante!",
        tags: ["remix", "chiptune", "epicbattlefantasy5"],
        releaseDate: new Date("2024-06-05"),
        panelClickUrl: "https://www.youtube.com/watch?v=ZGJgIYUw-tY",
        thumbnailUri: "/Images/YouTube Video Thumbnails/Music/Music_LaPlaisanterieSavante.jpg",
        isPixelated: true,
    },
    {
        id: "NEWS-WEBSITE_NEWS_INITIALIZATION",
        title: "Begun construction of News Panel!",
        tags: ["blawnode_com"],
        releaseDate: new Date("2024-05-13"),
        thumbnailUri: "/Images/YouTube Video Thumbnails/Music/Default Thumbnail.jpg",
        isPixelated: true,
    },
];*/

/*const newsPanelElements: React.JSX.Element[] = [

    ...(newsPosts.map(newsPost => (
        <NewsPanelElement key={newsPost.id}
                          newsId={newsPost.id}
                          title={newsPost.title}
                          date={stringifyDate(newsPost.releaseDate).replaceAll(".", '/')}
                          panelClickUrl={newsPost.panelClickUrl}
                          thumbnailUrl={newsPost.thumbnailUri}
                          isPixelated={newsPost.isPixelated}/>))),

    /*<NewsPanelElement title="News panel was created!" date="13/05/2024"/>,* /
];*/


// TODO: In coalesced_newsposts_public.json, sometimes there's a field relatedYtVideos. It's not acknowledged AT ALL.


// TODO: This updates on page load thrice, as of 25/09/2025. Once when page loads, twice when dynamo fetched, and twice when dynamo fetched AGAIN.
// TODO: This also updates whenever a post is clicked, prompting logs. There's surely a better way to go about it.
const NewsPanel = () => {
    const dispatch: AppDispatch = useDispatch();
    const { newsPostDatas, loading, error } = useSelector((state: RootState) => ({
        newsPostDatas: state.newsPostDatas,
        loading: state.loading,
        error: state.error
    }));
    useDebugValue(newsPostDatas, n => n?.length ?? "Loading news posts...");

    const isMobile = IsMobile();
    
    const NewsPanelHeader_IconSize = isMobile ? "24px" : "40px";
    const NewsPanelHeader = () =>
        <div style={{...NewsPanelHeaderStyle, marginBottom: "4px",}}>
            <h3>
                <img src="/UI%20Graphics/game-icons.net/newspaper.png"
                     alt="Newspaper Icon"
                     style={{height: NewsPanelHeader_IconSize, paddingRight: "12px",}}/>
                <span style={{fontSize: isMobile ? "calc(1rem + .4vw)" : "calc(1.3rem + .6vw)"}}>News</span>
                <img src="/UI%20Graphics/game-icons.net/newspaper.png"
                     alt="Newspaper Icon"
                     style={{height: NewsPanelHeader_IconSize, paddingLeft: "12px",}}/>
            </h3>
        </div>;

    const NewsErrorDisplay = () => (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "calc(100%)",
            padding: "20px",
            textAlign: "center",
            backgroundColor: "rgba(255, 107, 107, 0.1)",
            borderRadius: "8px",
            border: "2px solid #d95763",
            margin: "0 16px"
        }}>
            <div style={{ fontSize: isMobile ? "2rem" : "2rem", marginBottom: "10px" }}>
                ⚠️
            </div>
            <h3 style={{ 
                fontSize: isMobile ? "calc(0.8rem + .3vw)" : "calc(0.8rem + .3vw)",
                marginBottom: "10px",
                color: "#d95763"
            }}>
                Uh oh! An error has occurred!
            </h3>
            <p style={{ 
                fontSize: isMobile ? "calc(0.7rem + .2vw)" : "calc(0.5rem + .1vw)",
                marginBottom: "15px",
                color: "#fff",
                opacity: 0.8
            }}>
                {error}
            </p>
            <button
                onClick={() => dispatch(selectNewsPosts(useApi))}
                style={{
                    padding: "8px 16px",
                    backgroundColor: "#d95763",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: isMobile ? "calc(0.8rem + .2vw)" : "calc(0.9rem + .3vw)",
                    transition: "background-color 0.2s"
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#c84858"}
                onMouseDown={(e) => e.currentTarget.style.backgroundColor = "#ae424e"}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#d95763"}
            >
                Try Again
            </button>
        </div>
    );

    const NewsLoadingDisplay = () => (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            padding: "20px",
            textAlign: "center",
        }}>
            <div style={{ 
                fontSize: isMobile ? "2rem" : "3rem", 
                marginBottom: "10px",
                // animation: "spin 1s linear infinite",
                transformOrigin: "center"
            }}>
                <img src="/Blawnode_Logo_MAX.png" className="App-logo" alt="logo"
                style={{height: "8vmin",}}/>
            </div>
            <h3 style={{ 
                fontSize: isMobile ? "calc(0.8rem + .3vw)" : "calc(0.8rem + .3vw)",
                marginBottom: "10px",
                color: "#d77bba"
            }}>
                Loading news posts...
            </h3>
            <p style={{ 
                fontSize: isMobile ? "calc(0.7rem + .2vw)" : "calc(0.5rem + .1vw)",
                color: "#fff",
                opacity: 0.8
            }}>
                Please wait.
            </p>
        </div>
    );
    
    console.log("NewsPanel:Update: Selecting news post datas:");
    console.log(newsPostDatas);
    
    // Create news panel elements from the data
    const newsPanelElements: React.JSX.Element[] = [
        // Due to some JavaScript vs TypeScript shenanigans, newsPost1.releaseDate.getTime() treats newsPost1.releaseDate as a string.
        ...(newsPostDatas
            .sort((newsPost1, newsPost2) => new Date(newsPost2.releaseDate).getTime() - new Date(newsPost1.releaseDate).getTime())
            .map(newsPost => (
                <NewsPanelElement key={newsPost.id}
                    newsId={newsPost.id}
                    title={newsPost.title}
                    date={stringifyDate(newsPost.releaseDate).replaceAll(".", '/')}
                    panelClickUrl={newsPost.panelClickUrl}
                    thumbnailUrl={newsPost.thumbnailUri?.includes("/") ? newsPost.thumbnailUri
                        : "https://blawnode-com-news-thumbnails59fee-staging.s3.us-east-1.amazonaws.com/public/" + newsPost.thumbnailMetadata}
                    isPixelated={newsPost.isPixelated} />))),
    ];

    return <div id="news" style={{...NewsPanelStyle,}}>
        <div id="news-background" style={{...NewsPanelBackgroundStyle,}}>
        </div>
        <div id="news-foreground" style={{position: "relative", top: "-100%",
            height: "100%",
            padding: "8px",}}>
            <div style={isMobile ? {height: "20%",} : {height: "10%",}}><NewsPanelHeader/></div>

            {!isMobile && <div style={{height: "5%",}}/>}

            <div id="news-expandable-container" style={{width: "120%", height: isMobile ? "80%" : "85%",
            position: "relative", left: "-10%",
            overflowY: "scroll", scrollbarGutter: "stable both-edges", scrollbarWidth: "none",
            padding: 0,}}>
            <div id="news-resizer" style={{width: "83.34%", height: "100%", margin: "auto",
                padding: "8px",}}>
                <div style={{fontSize: "calc(3px + 1vmin)", width: "100%", height: "100%",}}>
                    {error ? (
                        <NewsErrorDisplay />
                    ) : loading ? (
                        <NewsLoadingDisplay />
                    ) : (
                        isMobile ? <NewsPanelElementScroller newsPanelElements={newsPanelElements}/> : newsPanelElements
                    )}
                </div>
            </div>
        </div>
        </div>
    </div>;
}

export default NewsPanel;